import { create } from 'zustand';

interface MessageStore {
    unreadCounts: Record<string, number>;
    setUnreadCount: (conversationId: string, count: number) => void;
    resetAllUnread: () => void;
}

export const useMessageStore = create<MessageStore>((set, get) => ({
    unreadCounts: {},

    setUnreadCount: (conversationId, count) => {
        const currentCount = get().unreadCounts[conversationId];
        if (currentCount === count) return;

        set((state) => ({
            unreadCounts: {
                ...state.unreadCounts,
                [conversationId]: count,
            },
        }));
    },

    resetAllUnread: () => set({ unreadCounts: {} }),
}));

// Selector for total unread count
export const selectTotalUnread = (state: MessageStore) => Object.values(state.unreadCounts).reduce((total, count) => total + count, 0);

export const selectUnreadForConversation = (conversationId: string) => (state: MessageStore) => state.unreadCounts[conversationId] || 0;